import { QuickPickTimes } from '~/reactapp/App/Publish/quickDates'

export interface LineConfig {
  unit: 'words' | 'chars' | null
  value: number | null
  linesPerInch: number | null
}

export interface PicklistItem {
  id: string
  text: string
  active: boolean
  default: boolean
  order?: number
}

interface FieldSettings {
  requiredPublish: boolean
  requiredSave: boolean
}

export interface ComposerSettings {
  // Is default synthetic (not from DB) template is visible
  defaultTemplateIdVisible?: boolean
  // An ID of the default template
  defaultTemplateId?: string
  dropCaps: boolean
  quickPickTimes: QuickPickTimes
  circulations?: {
    requiredToSave: boolean
  }
  timezone: string
  clockFormat: '12' | '24'
  customEmbed: {
    // view, edit, etc. should be URLs
    [subtype: string]: {
      view: string
      edit: string
      search: string
      loadTimeout?: number
      caption?: string
      icon: string
    }
  }
  lineSettings: {
    default: LineConfig
    websites: {
      [key: string]: LineConfig
    }
  }
  linkListSubtypes?: PicklistItem[]
  linkSubtypes?: PicklistItem[]
  locking?: {
    maxIdleTime: number
    warningTime: number
  }
  mediaOptions: {
    image: {
      showCaption: boolean
      showSubtitle: boolean
      showLink: boolean
      overridePhotographer: boolean
      overrideCredit: boolean
    }
    video: {
      showBlurb: boolean
      showTease: boolean
      showTitle: boolean
    }
    gallery: {
      showTitle: boolean
      showDescription: boolean
    }
  }
  proofreaders: {
    active: 'tansa' | 'proLexis' | 'arcSpellcheck'
    tansa: {
      companyId: string
      globalUserId: string
      clientUrl: string
      websiteUserIds: {
        [website: string]: string
      }
    }
    proLexis: {
      apiKey: string
      url: string
    }
    arcSpellcheck: {
      language: string
    }
  }
  featuredMedia?: {
    [key: string]: {
      label: string
      requiredToPublish: boolean
      types: string[]
    }
  }
  updatePaywallStatusBasedOnSite: boolean
  siteServiceHierarchy: string
  v2?: {
    metas: Array<{
      key: string
      settings: FieldSettings
    }>
    planning: Array<{
      key: string
      settings: FieldSettings
    }>
  }
}
